import { Pass, ATP, DrugDetailsEachOtherBottleSize, SamePillIdRecord } from './../../models/drug-details';
import { RpoToolService } from './../../services/rpo-tool.service';
import { RecommendedCanisterList, CanisterSubInfo, AssignCanister } from './../../models/canister';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Optional, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as constants from 'src/app/config/app-constants';
import { ImportWizardInventoryComponent } from '../import-wizard-inventory/import-wizard-inventory.component';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { DeviceData, DrugCharacteristics, Image } from '../../models/drug-details';
import { ImportWizardImageSlideComponent } from '../import-wizard-image-slide/import-wizard-image-slide.component';
import { HttpErrorResponse } from '@angular/common/http';
import { GetInventory } from '../../models/inventory';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { RecommendationDrug, UpdateDrug, UpdateDcr, DrugDataResponse } from '../../models/drug';
import { DropDown, DropDownDosageForm, DropDownTwo } from '../../models/dropdown';
import { debounceTime, distinctUntilChanged, filter, map, Observable, startWith, tap } from 'rxjs';
import { DropdownValues } from '../../models/synmed-data';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { ImportWizardAlertComponent } from '../import-wizard-alert/import-wizard-alert.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { AlertWizardComponent } from 'src/app/internal-user/im-tool/components/alert-wizard/alert-wizard.component';
import { ImportWizardPillIdDetailsComponent } from '../import-wizard-pill-id-details/import-wizard-pill-id-details.component';
import { OtherBottleSizeWizardComponent } from '../other-bottle-size-wizard/other-bottle-size-wizard.component';
import { MergeQuarantineDrugWizardComponent } from '../merge-quarantine-drug-wizard/merge-quarantine-drug-wizard.component';
import { QuarantineStateService } from 'src/app/shared/services/quarantine-state.service';

@Component({
  selector: 'app-import-wizard-drug-details',
  templateUrl: './import-wizard-drug-details.component.html',
  styleUrls: ['./import-wizard-drug-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false
})
export class ImportWizardDrugDetailsComponent implements OnInit {
  listOfClassificationShape: DropDown[] = [];
  isThirtyDramCapacityCalculating: boolean = false;
  isSynmedCalculating: boolean = false;
  isMaxCalculating: boolean = false;
  isTcgCalculating: boolean = false;
  isLegacyShow: boolean = true;
  dataSources: any[] = [];
  listOfPnr: DropDown[] = [];
  listOfATPDrugStatus: DropDown[] = [];
  listOfMAXDrugStatus: DropDown[] = [];
  listOfSynmedDrugStatus: DropDown[] = [];
  listOfSmallDropHeight: DropDown[] = [];
  listOfPASSDrugStatus: DropDown[] = [];
  listOfPillType: DropDown[] = [];
  listOfColor: DropDown[] = [];
  listOfCoating: DropDownTwo[] = [];
  listOfScoaring: DropDown[] = [];
  listOfDistributor: DropDown[] = [] as DropDown[]
  listOfDosageForm: DropDownDosageForm[] = [] as DropDownDosageForm[]
  listOfRoa: DropDown[] = [] as DropDown[]
  listOfManufacturer: DropDown[] = [] as DropDown[]
  listOfDrugName: DropDown[] = [] as DropDown[]
  listOfGenericName: DropDown[] = [] as DropDown[]
  listOfPackageType: DropDown[] = [] as DropDown[];
  listOfOTC: DropDown[] = [];
  listOfDnuReason: DropDown[] = [] as DropDown[];
  quarantineReasonList: DropDown[] = [] as DropDown[];
  shapeList: DropDown[] = [] as DropDown[];

  listOfDrugStatus: DropDown[] = [];

  validHeights = [1.00, 1.25, 1.50, 1.75, 2.00, 2.25, 2.50, 2.75, 3.00, 3.25, 3.50, 3.75, 4.00, 4.25, 4.50, 4.75];
  validWidths = ['A.00', 'A.25', 'A.50', 'A.75', 'B.00', 'B.25', 'B.50', 'B.75',
    'C.00', 'C.25', 'C.50', 'C.75', 'D.00', 'D.25', 'D.50', 'D.75',
    'E.00', 'E.25', 'E.50', 'E.75'];
  validPressures = [15, 20, 25, 30, 35, 40, 45, 50, 55, 60];
  validBaffles = [1, 2, 3, 4];

  pipetteSize = DropdownValues.PipetteSize;
  preferredPipetteSize = DropdownValues.PreferredPipetteSize;

  containerSize = DropdownValues.PreferredContainerSize;
  preferredContainerSize = DropdownValues.PreferredContainerSize;

  smallPipetteDropHeight = DropdownValues.SmallPipetteDropHeight;
  largePipetteDropHeight = DropdownValues.LargePipetteDropHeight;

  lidVolcanicOptions = DropdownValues.CommonBooleanDropDownValues;
  preferredLidVolcanicOptions = DropdownValues.CommonBooleanDropDownValues;

  lidHoleSize = DropdownValues.LidHoleSize;
  preferredLidHoleSize = DropdownValues.PreferredLidHoleSize;

  massIndex = DropdownValues.MassIndex;
  preferredMassIndex = DropdownValues.MassIndex;

  toggleOptions = DropdownValues.CommonBooleanDropDownValues;
  synmedLabOptimizeds = DropdownValues.CommonBooleanDropDownValues;
  fragileFlags = DropdownValues.CommonBooleanDropDownValues;


  countryList: DropDown[] = [];
  listOfDrugClassificationType: DropDown[] = [];
  scheduleList: DropDownTwo[] = [];
  unitList: DropDown[] = [];
  listOfNiosh: DropDown[] = [];
  ndc: string;
  dataSourceId: number;
  caseNo: string;
  drugCharacteristicsModel: DrugCharacteristics = {} as DrugCharacteristics
  otherBottleSizes: DrugDetailsEachOtherBottleSize[] = [];
  dataSourcePill: SamePillIdRecord[] = [];
  inventoryList: GetInventory[] = [];
  images: Image = {};
  devicesModel: DeviceData[] = [];
  passModel: Pass = {} as Pass;
  atpModel: ATP = {} as ATP;
  defaultImage: string = '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'
  dataSourceDevice = new MatTableDataSource<DeviceData>();
  listOfRecommendationDrug: RecommendationDrug[] = [];
  inventoryId: number = 0;
  dataSourceRecommendationDrug = new MatTableDataSource<RecommendedCanisterList>();
  expandedElement: RecommendedCanisterList | null;
  canisterData: RecommendedCanisterList[] = [];
  usersData: RecommendedCanisterList[] = [];
  assignCanisterModel: AssignCanister;
  drugUpdateModel: UpdateDrug;
  dcrUpdateModel: UpdateDcr;
  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<CanisterSubInfo>>;
  columnsToDisplay = ['isChecked', 'canisterRecipe', 'matchLevel', 'medName', 'dItem'];
  innerDisplayedColumns = ['pillType', 'length', 'width', 'thickness', 'pieceWeight', 'diagonal'];
  displayedDetailsColumns: string[] = ['partType', 'part', 'partNo']; // Column definitions

  drugAllInfo: DrugDataResponse = {} as DrugDataResponse
  isQuarantineDrugAlreadyResolved: boolean = false;

  dataSource = [];
  isRecommendedShow: boolean = false;
  isCanisterDetails: boolean = false;
  isSnapCanisterDetails: boolean = false;
  isLoading: boolean = false;
  drugName?: string;
  saveModelForm: FormGroup;
  isDcrClosed: boolean = false;
  // Colors
  @ViewChild('colorInput') colorInput: ElementRef<HTMLInputElement>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectedColors: string[] = [];
  allColors: string[] = [];
  filteredColors: Observable<string[]>;

  //#region  Extra parameters
  source: number;
  schemaName: string;
  drugId: number;
  canisterId?: string;
  snapCanisterId?: string;
  isDisableEditForSource: boolean = false;
  editCanSelection: number = 1;

  //#endregion

  genericName = new FormControl('')
  color = new FormControl('');
  scoringId = new FormControl('');
  packageTypeId = new FormControl('');
  distributorId = new FormControl('');
  routeOfAdminId = new FormControl('');
  dosageFormId = new FormControl('');
  isSuperCellOnly = new FormControl('');
  manufacturerId = new FormControl('');
  drugNameId = new FormControl('');
  drugStatusId = new FormControl('');
  species = new FormControl('');
  niosh = new FormControl('');
  listOfDrugNumberFormat: DropDown[] = [];
  filteredDrugNumberFormat: DropDown[] = [];
  listofUnit: { value: number; label: string }[] = [];
  isUnitExist: boolean = false;


  openOtherBottleSizesImportWizard() {
    const dialogRef = this.dialog.open(OtherBottleSizeWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        otherBottleSizes: this.otherBottleSizes,
        title: 'Other Bottle Sizes',
        cancelBtnText: "Cancel",
        confirmBtnText: "Ok",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("result", result);
    });
  }

  onToggleSourceChange(event: any) {
    this.saveModelForm.controls.isLegacy.setValue(event.checked);
    this.isLegacyShow = event.checked;
  }


  // Custom validator to ensure at most 2 colors are selected
  maxTwoColorsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const selectedColors = (control.value as string || '').split(',').filter(color => color.trim() !== '');
      return selectedColors.length > 2 ? { maxColors: true } : null;
    };
  }

  requiredColorValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const selectedColors = (control.value as string || '').split(',').filter(color => color.trim() !== '');
      return selectedColors.length === 0 ? { colorRequired: true } : null;
    };
  }
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value && this.allColors.includes(value) && !this.selectedColors.includes(value)) {
      if (this.selectedColors.length < 2) {
        this.selectedColors.push(value);
      } else {
        this.toastService.openToast(
          'You can select a maximum of 2 colors only',
          constants.ToastPanelType.error,
          2
        );
      }
    }

    event.chipInput!.clear();
    this.color.setValue(this.selectedColors.join(','));
    console.log(this.color);
    this.color.updateValueAndValidity();
  }

  remove(color: string): void {
    const index = this.selectedColors.indexOf(color);
    if (index >= 0) {
      this.selectedColors.splice(index, 1);
    }
    this.color.setValue(this.selectedColors.join(','));
    this.color.updateValueAndValidity();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    // Ensure value is not empty or invalid before adding to the selectedColors
    if (value && value.trim() !== '' && !this.selectedColors.includes(value)) {
      if (this.selectedColors.length < 2) {
        this.selectedColors.push(value);
      }
    }
    // this.filteredColors = new Observable<string[]>;
    this.allColors = []
    this.colorInput.nativeElement.value = ''; // Reset the input field
    this.color.setValue(this.selectedColors.join(',')); // Update the form control
    this.color.updateValueAndValidity(); // Re-validate the form control
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allColors.filter(color => color.toLowerCase().includes(filterValue));
  }

  constructor(
    public dialogRef: MatDialogRef<ImportWizardDrugDetailsComponent>,
    public dialog: MatDialog,
    private rpoToolService: RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private errorHandlerService: ErrorHandlerService,
    private toastService: ToastService,
    private cd: ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private quarantineStateService: QuarantineStateService) {
    this.ndc = data.ndc;
    this.dataSourceId = data.dataSourceId;
    this.caseNo = data.caseNo;

    // Subscribe to changes
    this.quarantineStateService.isQuarantineDrugAlreadyResolved$.subscribe(
      (status) => {
        this.isQuarantineDrugAlreadyResolved = status;
      }
    );
  }

  ngOnInit(): void {
    this.getQuarantineReasonList();
    this.getClassificationShape();
    this.getAtpDrugStatus();
    this.getPassDrugStatus();
    this.getMaxDrugStatus();
    this.getPillType();
    this.getCoating();
    this.getScoring();
    this.getCountryList();
    this.getDrugClassificationType();
    this.getSynmedDrugStatus();
    this.getDrugNonCountReasonList();
    this.getScheduleList();
    this.getUnitList();
    this.getShapeList();
    this.getCommonDrugStatus();
    this.getNiosh();
    this.getPnrList();
    this.loadAdditionalData();
    this.getDrugNumberFormat();
    setTimeout(() => {
      this.getDrugByndc();
    }, 1000)
    this.getUnit('');
    this.saveModelForm = new FormGroup({
      massIndex: new FormControl(''),
      preferredMassIndex: new FormControl(''),
      lidHole: new FormControl(''),
      lidVolcanic: new FormControl(null),
      preferredLidVolcanic: new FormControl(null),
      fragileFlag: new FormControl(''),
      toggle: new FormControl(''),
      preferredToggle: new FormControl(''),
      classificationShapeId: new FormControl(''),
      length: new FormControl(''),
      width: new FormControl(''),
      thickness: new FormControl(''),
      ridgeThickness: new FormControl(''),
      pieceWeight: new FormControl(''),
      diagonal: new FormControl(),
      ndc: new FormControl(''),
      dnumber: new FormControl(''),
      packageBarcode: new FormControl('',
        [
          Validators.minLength(10),
          Validators.maxLength(12)
        ]
      ),
      packageBarcode2d: new FormControl(''),
      packageThirtyDramCapacity: new FormControl(''),
      coatingId: new FormControl(''),
      quarantineId: new FormControl(''),
      shapeId: new FormControl(''),
      packageImprint1: new FormControl(''),
      packageImprint2: new FormControl(''),
      color: this.color,
      // color: this.color,
      scoringId: new FormControl(''),
      maxThirtyDramDnu: new FormControl(''),
      maxDoNotUse: new FormControl(''),
      maxDrugStatus: new FormControl(''),
      maxCellHeight: new FormControl(''),
      maxCellWidth: new FormControl(''),
      maxBaffle: new FormControl(''),
      maxPressure: new FormControl(''),
      maxLabOptimized: new FormControl(null),
      maxPnr: new FormControl({ value: '', disabled: true }),
      atpDrugStatus: new FormControl(''),
      atpPnr: new FormControl({ value: '', disabled: true }),
      atpTcgDiameter: new FormControl(''),
      atpTcgPillType: new FormControl(''),
      atpTcgPillVolume: new FormControl(''),
      atpTcgT1: new FormControl(''),
      atpTcgT2: new FormControl(''),
      atpTcgWidth: new FormControl(),
      atpTcgLength: new FormControl(),
      atpCanisterNumber: new FormControl(''),
      atpLabOptimized: new FormControl(null),
      passDrugStatus: new FormControl(''),
      passLabOptimized: new FormControl(null),
      passPnr: new FormControl({ value: '', disabled: true }),
      synmedLabOptimized: new FormControl(null),
      synmedPnr: new FormControl({ value: '', disabled: true }),
      recommendationType: new FormControl('1'),
      canisterEditSelection: new FormControl(1),
      snapCanisterManual: new FormControl('', Validators.pattern(/^\d{4}$/)),
      canisterManual: new FormControl('', Validators.pattern(/^\d{4}$/)),


      synmedDrugStatus: new FormControl(''),
      containerSize: new FormControl(''),
      pipetteSize: new FormControl(''),
      distributorId: this.distributorId,
      routeOfAdminId: this.routeOfAdminId,
      dosageFormId: this.dosageFormId,
      manufacturerId: this.manufacturerId,
      drugNameId: this.drugNameId,
      drugStatusId: this.drugStatusId,
      species: this.species,
      packageSize: new FormControl(''),
      packageDepth: new FormControl(0),
      packageHeight: new FormControl(0),
      packageTypeId: this.packageTypeId,
      packageWidth: new FormControl(0),
      drugClassificationType: new FormControl(''),
      drugNumberFormat: new FormControl(''),
      gtin: new FormControl('', [
        Validators.pattern(/^\d{12,}$/)
      ]),
      country: new FormControl(''),
      oralSolid: new FormControl(true),
      cellCapacity: new FormControl(),
      superCellCapacity: new FormControl(),
      canisterCapacity: new FormControl(),
      highCapCapacity: new FormControl(),

      nonCountReasonId: new FormControl(),
      largePipetteDropHeight: new FormControl(),
      smallPipetteDropHeight: new FormControl(),
      preferredLidHoleSize: new FormControl(),
      preferredContainerSize: new FormControl(),
      preferredPipetteSize: new FormControl(),
      smallCanisterCapacity: new FormControl(),
      largeCanisterCapacity: new FormControl(),
      sourceId: new FormControl(1),
      isLegacy: new FormControl(true),

      genericName: this.genericName,
      strength: new FormControl('', [this.strengthValidator.bind(this)]),
      unitId: new FormControl(),
      drugId: new FormControl(''),
      active: new FormControl(''),
      scheduleId: new FormControl(),
      manufacturer: new FormControl(''),
      otc: new FormControl(''),
      dosageForm: new FormControl(''),
      niosh: new FormControl(''),
      antibiotics: new FormControl(''),
      unitOfUse: new FormControl(''),
      unitDose: new FormControl(''),
      updated: new FormControl(''),
      storageConditions: new FormControl(''),
      gpi: new FormControl(''),
      gcn: new FormControl(''),
      shape: new FormControl(''),
      drugName: new FormControl(''),
      isSuperCellOnly: this.isSuperCellOnly,
      unit: new FormControl(''),
      otcId: new FormControl()
    });

    console.log("Form initialized:", this.saveModelForm);

    this.setupFormWatchers();

    console.log("Form watchers set up.");

    // Listen to OTC changes
    this.saveModelForm.get('otcId')?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(otcValue => {
        this.handleOtcChange(otcValue);
      });

    this.filteredColors = this.color.valueChanges.pipe(
      debounceTime(300), // Delay processing to allow user input stabilization
      distinctUntilChanged(), // Ignore duplicate values
      tap(value => {
        // Handle API call in a centralized manner
        if (value && !Number.isFinite(value)) {
          this.isLoading = true;
          setTimeout(() => {
            this.getColor(value); // Call API only for valid inputs
            this.isLoading = false;
          }, 400);
        }
      }),
      map((color: string | null) => (color ? this._filter(color) : this.allColors.slice())) // Filter colors for dropdown
    );

    // Handle initial value explicitly
    if (this.color.value && !Number.isFinite(this.color.value)) {
      this.getColor(this.color.value);
    }



    this.distributorId.valueChanges
      .pipe(
        debounceTime(300), // Wait 300ms for user input stabilization
        distinctUntilChanged(), // Ignore duplicate values
        filter(value => value && !Number.isFinite(value)) // Process only valid non-numeric values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getDistributor(searchTerm); // Make the API call
          this.isLoading = false;
        }, 400);
      });

    // Handle the initial value explicitly
    if (this.distributorId.value && !Number.isFinite(this.distributorId.value)) {
      this.getDistributor(this.distributorId.value);
    }




    this.routeOfAdminId.valueChanges
      .pipe(
        debounceTime(300), // Delay processing to wait for user input to stabilize
        distinctUntilChanged(), // Ignore duplicate values
        filter(value => value && !Number.isFinite(value)) // Process only non-null, non-numeric values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getRoa(searchTerm); // API call
          this.isLoading = false;
        }, 400);
      });

    // Handle initial value explicitly
    if (this.routeOfAdminId.value && !Number.isFinite(this.routeOfAdminId.value)) {
      this.getRoa(this.routeOfAdminId.value);
    }




    this.manufacturerId.valueChanges
      .pipe(
        debounceTime(300), // Delay for 300ms after the last input
        distinctUntilChanged(), // Prevent duplicate emissions
        filter(value => value && !Number.isFinite(value)) // Skip null, undefined, or numeric values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getManufacture(searchTerm); // Call the API only for valid values
          this.isLoading = false;
        }, 400);
      });

    // Handle the initial value explicitly
    if (this.manufacturerId.value && !Number.isFinite(this.manufacturerId.value)) {
      this.getManufacture(this.manufacturerId.value);
    }

    this.drugNameId.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(value => value && !Number.isFinite(value))
      )
      .subscribe(searchTerm => {
        setTimeout(() => {
          if (searchTerm && searchTerm.length > 2) {
            this.isLoading = true;
            this.getDrugName(searchTerm);
          }
          else {
            this.listOfDrugName = [];
          }
          this.isLoading = false;
        }, 400);
      });

    if (this.drugNameId.value && !Number.isFinite(this.drugNameId.value)) {
      this.getDrugName(this.drugNameId.value);
    }


    this.genericName.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(value => value && !Number.isFinite(value))
      )
      .subscribe(searchTerm => {
        setTimeout(() => {
          if (searchTerm && searchTerm.length > 2) {
            this.isLoading = true;
            this.getGenericName(searchTerm);
          }
          else {
            this.listOfGenericName = [];
          }
          this.isLoading = false;
        }, 400);
      });

    if (this.genericName.value && !Number.isFinite(this.genericName.value)) {
      this.getGenericName(this.genericName.value);
    }



    this.dosageFormId.valueChanges
      .pipe(
        debounceTime(300), // Wait 300ms after the last input
        distinctUntilChanged(), // Ignore duplicate values
        filter(value => value && !Number.isFinite(value)) // Skip null, undefined, or numeric values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getDosageForm(searchTerm); // Call the API
          this.isLoading = false;
        }, 400);
      });

    // Handle the initial value explicitly
    if (this.dosageFormId.value && !Number.isFinite(this.dosageFormId.value)) {
      this.getDosageForm(this.dosageFormId.value);
    }



    this.packageTypeId.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(), // Ensures API is not called for duplicate values
        filter(value => value && !Number.isFinite(value)) // Skip invalid or empty values
      )
      .subscribe(searchTerm => {
        this.isLoading = true;
        setTimeout(() => {
          this.getPackageType(searchTerm); // Call the API
          this.isLoading = false;
        }, 400);
      });

    this.saveModelForm.get('sourceId')?.setValue(this.dataSourceId);

  }

  // Update Schedule data Changes based on OTC value
  handleOtcChange(otcValue: string) {
    const scheduleControl = this.saveModelForm.get('scheduleId');
    console.log(scheduleControl, "scheduleControl");


    if (otcValue === '7') { // Yes selected
      const otcSchedule = this.scheduleList.find(option => parseInt(option.key) === 7);
      console.log(otcSchedule.key, typeof (otcSchedule.key), otcSchedule, "otcSchedule----");

      // Set schedule to value 7 and disable
      scheduleControl.setValue(otcSchedule.key, { emitEvent: true });
      scheduleControl?.disable();
    } else if (otcValue === '8') { // No selected
      console.log(scheduleControl.value, typeof (scheduleControl.value), "otcSchedule----");
      // Enable schedule dropdown and clear value
      scheduleControl?.enable();
      scheduleControl.setValue(scheduleControl.value, { emitEvent: true });
    }
  }

  // Disable Schedule dropdown if in OTC dropdown user selected YES
  isScheduleDisabled(): boolean {
    return this.saveModelForm.get('otcId')?.value === '7';
  }


  displayFnColor(value?: any) {
    if (this.listOfColor.length == 0) {
      return undefined
    }
    else {
      return value ? this.listOfColor.find(_ => _.value === value).label : undefined;
    }
  }

  displayFnDistributor(value?: any) {
    if (this.listOfDistributor.length == 0) {
      return undefined
    }
    else {
      let data = value ? this.listOfDistributor.find(_ => _.value === value).label : undefined;
      this.listOfDistributor = [] as DropDown[];
      return data;
    }
  }
  displayFnDosageForm(value?: any) {
    if (this.listOfDosageForm.length == 0) {
      return undefined
    }
    else {
      let data = value ? this.listOfDosageForm.find(_ => _.id === value).description : undefined;
      this.listOfDosageForm = [] as DropDownDosageForm[];
      return data;
    }
  }

  displayFnRoa(value?: any) {
    if (this.listOfRoa.length == 0) {
      return undefined
    }
    else {
      let data = value ? this.listOfRoa.find(_ => _.value === value).label : undefined;
      this.listOfRoa = [] as DropDown[];
      return data;
    }
  }

  displayFnManufacturer(value?: any) {
    if (this.listOfManufacturer.length == 0) {
      return undefined
    }
    else {
      let data = value ? this.listOfManufacturer.find(_ => _.value === value).label : undefined;
      this.listOfManufacturer = [] as DropDown[];
      return data;
    }
  }

  displayFnDrugName(value?: any) {
    return value;
  }

  displayFnGenericName(value?: any) {
    return value;
  }

  displayFnPacakgeType(value?: any) {
    if (this.listOfPackageType.length == 0) {
      return undefined
    }
    else {
      return value ? this.listOfPackageType.find(_ => _.value === value).label : undefined;
    }
  }


  displayFnDrugStatus(value?: any) {
    if (this.listOfDrugStatus.length == 0) {
      return undefined
    }
    else {
      return value ? this.listOfDrugStatus.find(_ => _.value === value).label : undefined;
    }
  }

  displayedColumns: string[] = ['deviceName', 'drugStatus', 'deviceStatus', 'labOptimizedStatus']

  canisterChecked(row: any, isChecked: boolean) {

    this.assignCanisterModel = {
      ndc: this.drugCharacteristicsModel.drugId,
      canisterRecipe: this.saveModelForm.value.recommendationType == 1 ? row.canisterRecipe : null,
      snapRecipe: this.saveModelForm.value.recommendationType == 2 ? row.snapRecipe : null
    }

  }
  inventorySelect(inventoryId: number, isChecked: boolean) {
    this.inventoryId = inventoryId;
  }

  toggleRow(element: RecommendedCanisterList) {
    element.canisters && (element.canisters as MatTableDataSource<CanisterSubInfo>).data.length ? (this.expandedElement = this.expandedElement === element ? null : element) : null;
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<CanisterSubInfo>).sort = this.innerSort.toArray()[index]);
  }
  openDrugDetailsImportWizard() {
    const dialogRef = this.dialog.open(ImportWizardDrugDetailsComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
    });

  }
  forbiddenNamesValidator(Services: any[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

      // Always return null to allow any value
      return null;
    };
  }

  forbiddenColorValidator(Services: any[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!Services) {
        return null;
      }
      if (!isNaN(Number(control.value))) {
        return null;
      }
      if (!control.value) {
        return null;
      }

      const index = Services.findIndex(Service => {
        const escapedId = this.escapeRegExp(Service.value.toString());
        return new RegExp(`^${escapedId}$`).test(control.value);
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }




  escapeRegExp(input: string): string {
    return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  forbiddenIdValidator(Services: any[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }

      const index = Services.findIndex(Service => {
        const escapedId = this.escapeRegExp(Service.id.toString());
        return new RegExp(`^${escapedId}$`).test(control.value);
      });

      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }



  positiveRealNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      // Convert to string and trim
      const stringValue = String(value).trim();

      if (stringValue === '') {
        return null;
      }

      // Updated regex to allow numbers starting with 0 (like 0.1, 0.5)
      const positiveNumberPattern = /^(0\.\d+|[1-9]\d*(\.\d+)?)$/;
      const fractionPattern = /^(0\.\d+|[1-9]\d*(\.\d+)?)(\s*\/\s*(0\.\d+|[1-9]\d*(\.\d+)?))+$/;

      const isValid = positiveNumberPattern.test(stringValue) || fractionPattern.test(stringValue);
      return !isValid ? { positiveRealNumber: true } : null;
    };
  }

  openImportWizardInventory(status: number = 1) {
    this.drugInforUpdateApi(false);
    const dialogRef = this.dialog.open(ImportWizardInventoryComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
      data: {
        inventoryWizardStatus: status,
        schemanName: this.schemaName,
        drugInfo: {
          genericName: this.drugCharacteristicsModel.genericName,
          strength: this.drugCharacteristicsModel.strength,
          unit: this.drugCharacteristicsModel.unit,
          drugNumber: this.drugCharacteristicsModel.drugId,
          inventoryNumber: this.inventoryId
        }

      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.getInventoryByNdc();
        this.loadAdditionalData();
        this.inventoryId = 0;
      } else {
        console.log("not export", result);
      }
    });
  }
  openImportWizardPillID() {
    const dialogRef = this.dialog.open(ImportWizardPillIdDetailsComponent, {
      backdropClass: ['lgDialog'],
      disableClose: false,
      data: {
        pillId: this.drugCharacteristicsModel.pillId,
        dataSourcePill: this.dataSourcePill,
        ndc: this.ndc,
        dataSourceId: this.dataSourceId,
        drugName: this.drugName,
        images: this.images
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      //this.getDrugData();
    });
  }


  getCoating() {
    this.ngxLoader.start();
    this.rpoToolService.getCoating().subscribe({
      next: (result) => {
        this.listOfCoating = result.data;
        this.ngxLoader.stop();
      },
      error: (error) => this.errorHandlerService.handleError(error),
    });
  }
  getScoring() {
    this.ngxLoader.start();
    this.rpoToolService
      .getScoring()
      .subscribe({
        next: (result) => {
          this.listOfScoaring = result.data;
          this.ngxLoader.stop();
        },
        error: (error) => this.errorHandlerService.handleError(error),
      });
  }

  getPillType() {
    this.ngxLoader.start();
    this.rpoToolService
      .getPillType()
      .subscribe({
        next: (result) => {
          this.listOfPillType = result.data;
          this.ngxLoader.stop();
        },
        error: (error) => this.errorHandlerService.handleError(error),
      }
      );
  }

  getCountryList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getCountryList()
      .subscribe(
        (result) => {
          this.countryList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getDrugNumberFormat() {
    this.ngxLoader.start();
    this.rpoToolService
      .getDrugNumberFormat()
      .subscribe(
        (result) => {
          this.listOfDrugNumberFormat = result.data;
          this.filteredDrugNumberFormat = this.listOfDrugNumberFormat;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }


  updateDrugNumberFormat(): void {
    const classificationType = this.saveModelForm.controls.drugClassificationType.value;
    this.toggleGTINField(classificationType);

    this.filteredDrugNumberFormat = this.listOfDrugNumberFormat.filter(dnfOption => {
      switch (classificationType) {
        case 1: // Custom Mnemonic
          return dnfOption.label === '';
        case 2: // DIN 8
          return dnfOption.label === '';
        case 4: // NDC 11
          return dnfOption.label === '5-4-2';
        case 3: // NDC 10
          return ['4-4-2', '5-3-2', '5-4-1'].includes(dnfOption.label as string);
        case 5: // 'NDC 12'
          return dnfOption.label === '6-4-2';
        case 6: // UPC 10
          return dnfOption.label === '5-5';
        case 7: // UPC 12
          return dnfOption.label === '1-5-5-1';
        default:
          return true;
      }
    });

    const drugNumberFormatControl = this.saveModelForm.controls.drugNumberFormat;
    const isOptional = [1, 2, 5].includes(classificationType); // Custom Mnemonic, DIN 8, NDC 12

    // Always clear validators to allow any format
    drugNumberFormatControl.clearValidators();

    drugNumberFormatControl.updateValueAndValidity();

    // Auto-select if only one format is available
    if (this.filteredDrugNumberFormat.length === 1) {
      this.saveModelForm.controls.drugNumberFormat.setValue(this.filteredDrugNumberFormat[0].value);
    }
  }

  getDrugClassificationType() {
    this.ngxLoader.start();
    this.rpoToolService
      .getDrugClassificationType()
      .subscribe(
        (result) => {
          this.listOfDrugClassificationType = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getColorCodeByStatus(status: string | null): string {
    status = status?.trim();

    switch (status) {
      case 'Do Not Use':
        return '#f06616';           // Color for 'Do Not Use'
      case 'In Production-VS':
        return '#0352ba';
      case 'IN PRODUCTION':
        return '#0352ba';
      case 'IN PRODUCTION':
        return '#0352ba';          // Color for 'In Production-VS'
      case 'LabOptimized':
        return '#403E3E';
      case 'Non-Certified':
        return '#ffa54d';           // Color for 'Non-Certified'
      case '_':
      case null:
        return '';                  // No color for null or '_'
      default:
        return '#403E3E';           // Default light black color for other cases
    }
  }

  checkQuarantineDrugAlreadyResolvedOrNotBasedOnDnumber(dnumberFromApi: string) {
    const dnumber = dnumberFromApi ? dnumberFromApi && dnumberFromApi.split('D')[1] : null
    this.rpoToolService.checkQuarantineDrugAlreadyResolved(dnumber).subscribe((response) => {
      let result = response.data;
      console.log(result, "checkQuarantineDrugAlreadyResolvedOrNotBasedOnDnumber");

      this.isQuarantineDrugAlreadyResolved = result ? true : false;
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        console.log(error);
        this.toastService.openToast(error.error.message === undefined ?
          'Something went wrong!!' : error.error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }

  getDrugByndc() {
    this.rpoToolService.getDrugDetailsByNdc(this.ndc, this.dataSourceId).subscribe((response) => {
      let result = response.data

      // Check if Quarantine Drug already resolved or not.. based on that remove Resolve button
      this.checkQuarantineDrugAlreadyResolvedOrNotBasedOnDnumber(result.characteristics.dnumber);

      if (result.characteristics?.id === 0 || result.characteristics?.id == null) {
        this.toastService.openToast("No data found for this source",
          constants.ToastPanelType.error,
          2
        );
        return;
      }

      
      this.drugName = result.medName;
      this.drugId = result.characteristics.id;
      this.schemaName = result.characteristics.schemaName;
      this.source = result.characteristics.source;
      this.otherBottleSizes = result.otherBottleSizes;
      this.dataSourcePill = result.samePillIDRecords;
      if (result.characteristics.source === 3) {
        this.isDisableEditForSource = false;
      }
      else {
        this.isDisableEditForSource = true;
      }

      //characteristics
      this.drugAllInfo = result
      this.drugCharacteristicsModel.active = result.characteristics.active;
      this.drugCharacteristicsModel.genericName = result.characteristics.genericName;
      this.drugCharacteristicsModel.drugName = result.characteristics.primaryName;
      this.drugCharacteristicsModel.strength = result.characteristics.strength;
      this.drugCharacteristicsModel.gpi = result.characteristics.gpi;
      this.drugCharacteristicsModel.gcn = result.characteristics.gcn;
      this.drugCharacteristicsModel.countryCode = result.characteristics.countryCode;
      this.drugCharacteristicsModel.distributor = result.characteristics.distributor;
      this.drugCharacteristicsModel.distributorId = result.characteristics.distributorId;
      this.drugCharacteristicsModel.drugStatusId = result.characteristics.drugStatusId;
      this.drugCharacteristicsModel.species = result.characteristics.species;
      this.drugCharacteristicsModel.unitId = result.characteristics.unitId;
      this.drugCharacteristicsModel.drugId = result.characteristics.drugId;
      this.drugCharacteristicsModel.schedule = result.characteristics.schedule;
      this.drugCharacteristicsModel.antibiotics = result.characteristics.antibiotics;
      this.drugCharacteristicsModel.dosageFormId = result.characteristics.dosageFormId;
      this.drugCharacteristicsModel.unit = result.characteristics.unit;
      const dosageForm = result.characteristics.dosageForm;
      if (dosageForm?.includes('||')) {
        const [dosageFormSource, dosageFormStd] = dosageForm.split('||');
        this.drugCharacteristicsModel.dosageForm = dosageFormSource;
        this.drugCharacteristicsModel.dosageFormStd = dosageFormStd || null;
      } else {
        this.drugCharacteristicsModel.dosageFormStd = dosageForm || null;
      }

      this.drugCharacteristicsModel.manufacturer = result.characteristics.manufacturer;
      this.drugCharacteristicsModel.manufacturerId = result.characteristics.manufacturerId;
      this.drugCharacteristicsModel.niosh = result.characteristics.niosh;
      // check if value exists in dropdown
      const exists = this.listOfNiosh.some(x => x.value === this.drugCharacteristicsModel.niosh);
      if (!exists && this.drugCharacteristicsModel.niosh) {
        this.listOfNiosh.push({
          label: this.drugCharacteristicsModel.niosh,
          value: this.drugCharacteristicsModel.niosh,
          description: this.drugCharacteristicsModel.niosh,
        });
      }

      this.saveModelForm.controls.dnumber.setValue(result.characteristics.dnumber);
      this.drugCharacteristicsModel.packageSize = result.characteristics.packageSize;
      this.drugCharacteristicsModel.packaging = result.characteristics.packaging;
      this.drugCharacteristicsModel.routeOfAdminId = result.characteristics.routeOfAdminId;
      const roa = result.characteristics.roa;
      if (roa?.includes('||')) {
        const [roaSource, roaStd] = roa.split('||');
        this.drugCharacteristicsModel.roa = roaSource;
        this.drugCharacteristicsModel.roaStd = roaStd || null;
      } else {
        this.drugCharacteristicsModel.roaStd = roa || null;
      }

      this.drugCharacteristicsModel.storageConditions = result.characteristics.storageConditions;
      this.drugCharacteristicsModel.unitDose = result.characteristics.unitDose;
      this.drugCharacteristicsModel.unitOfUse = result.characteristics.unitOfUse;
      this.drugCharacteristicsModel.updated = result.characteristics.updated;
      this.drugCharacteristicsModel.drugStatus = result.characteristics.drugStatus;
      this.drugCharacteristicsModel.drugStatusColor = result.characteristics.drugStatusColor;
      this.drugCharacteristicsModel.quarantined = result.characteristics.quarantined;
      this.saveModelForm.controls.quarantineId.setValue(result.characteristics.quarantineId);
      this.saveModelForm.controls.shapeId.setValue(result.characteristics.shapeId);
      this.drugCharacteristicsModel.quarantinedColor = result.characteristics.quarantinedColor;
      this.drugCharacteristicsModel.quarantineReason = result.characteristics.quarantineReason;
      this.drugCharacteristicsModel.shapeId = result.characteristics.shapeId;
      this.drugCharacteristicsModel.quarantineId = result.characteristics.quarantineId;
      this.drugCharacteristicsModel.shape = result.characteristics.shape;
      this.drugCharacteristicsModel.pillId = result.characteristics.pillId;
      this.images.serialImage = `data:image/png;base64,${result?.serialImage == undefined || result?.serialImage == null ? this.defaultImage : result?.serialImage}`;
      this.images.imageName = result.images?.imageName;
      // packages
      // this.saveModelForm.controls.packageBarcode.setValue(result.characteristics.barcode);
      // const barcode = result.characteristics.barcode2d?.includes('||') ? result.characteristics.barcode2d.split('||')[1] || null : result.characteristics.barcode2d;
      // this.saveModelForm.controls.packageBarcode2d.setValue(barcode);

      // Correctly set the UPC Barcode to the correct form control
      this.saveModelForm.controls.packageBarcode.setValue(result.characteristics.barcode ?? '');

      // Set 2D Barcode only if data is available; otherwise, keep it empty
      const barcode2D = result.characteristics.barcode2d?.includes('||')
        ? result.characteristics.barcode2d.split('||')[1] || null
        : result.characteristics.barcode2d;
      this.saveModelForm.controls.packageBarcode2d.setValue(barcode2D ?? '');
      this.saveModelForm.controls.packageThirtyDramCapacity.setValue(result.characteristics.thirtyDramCapacity);
      this.saveModelForm.controls.coatingId.setValue(result.characteristics.coatingId);
      this.saveModelForm.controls.packageImprint1.setValue(result.characteristics.imprint1);
      this.saveModelForm.controls.packageImprint2.setValue(result.characteristics.imprint2);
      this.saveModelForm.controls.packageDepth.setValue(result.characteristics.packageDepth);
      this.saveModelForm.controls.packageHeight.setValue(result.characteristics.packageHeight);
      this.saveModelForm.controls.packageWidth.setValue(result.characteristics.packageWidth);
      this.saveModelForm.controls.packageSize.setValue(result.characteristics.packageSize);
      this.saveModelForm.controls.packageTypeId.setValue(result.characteristics.packageTypeId);
      this.saveModelForm.controls.country.setValue(result.characteristics.countryCodeId);
      this.saveModelForm.controls.drugClassificationType.setValue(result.characteristics.drugNumberTypeId);
      this.saveModelForm.controls.drugNumberFormat.setValue(result.characteristics.drugNumberFormatId);
      this.saveModelForm.controls.gtin.setValue(result.characteristics.gtin);
      this.saveModelForm.get('gtin')?.[result.characteristics.drugNumberTypeId === 6 || result.characteristics.drugNumberTypeId === 7 ? 'disable' : 'enable']();
      this.saveModelForm.controls.length.setValue(result?.characteristics?.length == null ? 0 : result?.characteristics?.length);
      this.saveModelForm.controls.width.setValue(result?.characteristics?.width == null ? 0 : result?.characteristics?.width);
      this.saveModelForm.controls.thickness.setValue(result?.characteristics?.thickness == null ? 0 : result?.characteristics?.thickness);
      this.saveModelForm.controls.ridgeThickness.setValue(result?.characteristics?.ridgeThickness == null ? 0 : result?.characteristics?.ridgeThickness);
      this.saveModelForm.controls.pieceWeight.setValue(result?.characteristics?.weight == null ? 0 : result?.characteristics?.weight);
      this.saveModelForm.controls.diagonal.setValue(result?.characteristics?.diagonal == null ? 0 : result?.characteristics?.diagonal);
      this.saveModelForm.controls.classificationShapeId.setValue(result?.characteristics?.classificationShapeId);
      //characteristics
      this.saveModelForm.controls.genericName.setValue(result.characteristics.genericName);
      this.saveModelForm.controls.storageConditions.setValue(result.characteristics.storageConditions);
      this.saveModelForm.controls.drugName.setValue(result.characteristics.primaryName);
      this.saveModelForm.controls.unit.setValue(result.characteristics.unit);
      this.isUnitExist = result.characteristics.unit ? true : false;
      const combinedStrength = this.isUnitExist
        ? `${result.characteristics.strength} ${result.characteristics.unit}`.trim()
        : `${result.characteristics.strength}`.trim();
      this.saveModelForm.controls.strength.setValue(combinedStrength);
      this.saveModelForm.controls.unitId.setValue(result.characteristics.unitId);
      this.saveModelForm.controls.drugId.setValue(result.characteristics.drugId);
      this.saveModelForm.controls.active.setValue(result.characteristics.active);
      this.saveModelForm.controls.scheduleId.setValue(result.characteristics.scheduleId);
      this.saveModelForm.controls.manufacturerId.setValue(result.characteristics.manufacturerId);
      this.saveModelForm.controls.routeOfAdminId.setValue(result.characteristics.routeOfAdminId);
      this.saveModelForm.controls.distributorId.setValue(result.characteristics.distributorId);
      this.saveModelForm.controls.drugStatusId.setValue(result.characteristics.drugStatusId);
      this.saveModelForm.controls.species.setValue(result.characteristics.species);
      const otcValue = result.characteristics.scheduleId === 7 ? '7' : '8'; // 7 = Yes, 8 = No
      this.saveModelForm.controls.otcId.setValue(otcValue);
      this.drugCharacteristicsModel.otc = otcValue === '7' ? 'Yes' : 'No';
      this.saveModelForm.controls.dosageFormId.setValue(result.characteristics.dosageFormId);
      this.saveModelForm.controls.niosh.setValue(result.characteristics.niosh);
      this.saveModelForm.controls.antibiotics.setValue(result.characteristics.antibiotics);
      const unitOfUse = result.characteristics.unitOfUse === 'No' ? '0' : result.characteristics.unitOfUse === 'Yes' ? '1' : null;
      const unitDose = result.characteristics.unitDose === 'No' ? '0' : result.characteristics.unitDose === 'Yes' ? '1' : null;
      this.saveModelForm.controls.unitOfUse.setValue(unitOfUse);
      this.saveModelForm.controls.unitDose.setValue(unitDose);
      this.saveModelForm.controls.scoringId.setValue(result.characteristics.scoringId);
      const gpi = (result.characteristics.gpi != null ? result.characteristics.gpi : '') +
        (result.characteristics.gcn != null ? result.characteristics.gcn : '');
      this.saveModelForm.controls.gpi.setValue(gpi.replace('--', ''));
      this.saveModelForm.controls.oralSolid.setValue(result.characteristics.oralSolid);
      // Color handling
      if (result.characteristics.color) {
        const color = result.characteristics.color;

        // If color contains '||', split it into two parts
        if (color?.includes('||')) {
          const [color1, color2] = color.split('||');

          // Check if either color is empty and set the selectedColors accordingly
          if (color1.trim() === '' || color2.trim() === '') {
            this.selectedColors = []; // Set to empty array if any color is empty
            this.color.setValue('');
          } else {
            this.selectedColors = [color2]; // Only set the second color (color2) as selected
            this.color.setValue(color);
          }
        } else {
          // If color doesn't contain '||', handle as a single color
          if (color.trim() === '') {
            this.selectedColors = []; // Set to empty array if color is empty
            this.color.setValue('');
          } else {
            this.selectedColors = color.includes(",") ? color.split(',') : [color]; // Add the color to selectedColors
            this.color.setValue(color);
          }
        }
      }

      console.log(this.selectedColors, "this.selectedColors-----");

      this.updateDrugNumberFormat();

      this.listOfDistributor.push({
        value: result.characteristics.distributorId,
        label: result.characteristics.distributor,
        description: ''
      });
      this.listOfDosageForm.push({
        id: result.characteristics.dosageFormId,
        description: this.drugCharacteristicsModel.dosageFormStd,
      });

      this.listOfRoa.push({
        value: result.characteristics.routeOfAdminId,
        label: this.drugCharacteristicsModel.roaStd,
        description: ''
      });

      this.listOfManufacturer.push({
        value: result.characteristics.manufacturerId,
        label: result.characteristics.manufacturer,
        description: ''
      });

      this.drugNameId.setValue(result.characteristics.primaryName)
      this.drugNameId.updateValueAndValidity(); // Re-validate the form control

      if (result.characteristics.packageTypeId && result.characteristics.packaging) {
        this.listOfPackageType = [{
          value: result.characteristics.packageTypeId,
          label: result.characteristics.packaging,
          description: ''
        }];
      }

      result?.devices.forEach(element => {
        // Skip BEACON devices - they should not be displayed
        if (element.deviceName === 'BEACON') {
          return;
        }

        this.devicesModel.push({
          deviceName: element.deviceName,
          rateofUse: element.rateofUse,
          drugStatus: element.drugRecord?.replace('_', ' '),
          deviceStatus: element.deviceName === 'MAX' ? element.maxDrugStatus :
            element.deviceName === 'ATP' ? element.atpDrugStatus :
              element.deviceName === 'PASS' ? element.passDrugStatus :
                element.deviceName === 'SYNMED' ? element.synmedDrugStatus :
                  null,//element.deviceRecord?.replace('_', ' '),
          deviceStatusColor: element.deviceRecordColor,
          drugRecordColor: element.drugRecordColor,
          labOptimizedStatus: element.labOptimizedStatus == null || element.labOptimizedStatus == "" ? "No" : element.labOptimizedStatus
        })

        if (element.deviceName === 'PASS') {

          this.passModel.canisterId = element.canisterId;
          this.passModel.dnuReason = element.dnuReason;
          this.passModel.snapCanisterId = element.snapCanisterId;
          this.snapCanisterId = element.snapCanisterId;
          this.canisterId = element.canisterId;

          this.saveModelForm.controls.passDrugStatus.setValue(element.passDrugStatus);
          this.saveModelForm.controls.passPnr.setValue(this.resolvePnrControlValue(element.passPnr));
          this.PnrDropdownDisableForPass();
          this.saveModelForm.controls.passLabOptimized.setValue(element.labOptimized);
        }
        else if (element.deviceName === 'MAX') {
          this.saveModelForm.controls.maxThirtyDramDnu.setValue(Number(element.thirtyDramDnu));
          this.saveModelForm.controls.maxDoNotUse.setValue(Number(element.doNotUse));
          this.saveModelForm.controls.maxDrugStatus.setValue(element.maxDrugStatus);
          this.saveModelForm.controls.maxPnr.setValue(this.resolvePnrControlValue(element.maxPnr));
          this.PnrDropdownDisableForMax();
          this.saveModelForm.controls.maxCellHeight.setValue(element.cellHeight);
          this.saveModelForm.controls.maxCellWidth.setValue(element.cellWidth);
          this.saveModelForm.controls.maxBaffle.setValue(element.baffle);
          this.saveModelForm.controls.maxPressure.setValue(element.pressure);
          this.saveModelForm.controls.maxLabOptimized.setValue(element.labOptimized);
          this.saveModelForm.controls.cellCapacity.setValue(element.cellCapacity);
          this.saveModelForm.controls.superCellCapacity.setValue(element.superCellCapacity);
          this.saveModelForm.controls.isSuperCellOnly.setValue(element.isSuperCellOnly);
        }
        else if (element.deviceName === 'SYNMED') {
          this.saveModelForm.controls.massIndex.setValue(element.massIndex);
          this.saveModelForm.controls.preferredMassIndex.setValue(element.preferredMassIndex);

          this.saveModelForm.controls.lidHole.setValue(element.lidHoleSize);
          this.saveModelForm.controls.preferredLidHoleSize.setValue(element.preferredLidHoleSize);

          this.saveModelForm.controls.lidVolcanic.setValue(element.lidVolcanic);
          this.saveModelForm.controls.preferredLidVolcanic.setValue(element.preferredLidVolcanic);

          this.saveModelForm.controls.fragileFlag.setValue(element.fragileFlag);
          this.saveModelForm.controls.toggle.setValue(element.toggleFlag);
          this.saveModelForm.controls.preferredToggle.setValue(element.preferredToggleFlag);
          this.saveModelForm.controls.synmedDrugStatus.setValue(element.synmedDrugStatus);
          this.saveModelForm.controls.synmedPnr.setValue(this.resolvePnrControlValue(element.synMedPnr));
          this.PnrDropdownDisableForSynmed();
          this.saveModelForm.controls.synmedLabOptimized.setValue(element.labOptimized);
          this.saveModelForm.controls.nonCountReasonId.setValue(element.nonCountReasonId);

          this.saveModelForm.controls.preferredContainerSize.setValue(element.preferredContainerSize);
          this.saveModelForm.controls.pipetteSize.setValue(element.pipetteSize);

          this.saveModelForm.controls.containerSize.setValue(element.containerSize);
          this.saveModelForm.controls.preferredPipetteSize.setValue(element.preferredPipetteSize);

          this.saveModelForm.controls.largePipetteDropHeight.setValue(element.largePipetteDropHeight);
          this.saveModelForm.controls.smallPipetteDropHeight.setValue(element.smallPipetteDropHeight);
        }
        else if (element.deviceName === 'ATP') {
          this.saveModelForm.controls.atpDrugStatus.setValue(element.atpDrugStatus);
          this.saveModelForm.controls.atpPnr.setValue(this.resolvePnrControlValue(element.atpPnr));
          this.PnrDropdownDisableForAtp();
          this.saveModelForm.controls.atpTcgDiameter.setValue(element.tcgDiameter)
          this.saveModelForm.controls.atpTcgPillType.setValue(element.tcgPillType)
          this.saveModelForm.controls.atpTcgPillVolume.setValue(element.tcgPillVolume)
          this.saveModelForm.controls.atpTcgWidth.setValue(element.tcgWidth)
          this.saveModelForm.controls.atpTcgLength.setValue(element.tcgLength)
          this.saveModelForm.controls.atpCanisterNumber.setValue(element.canisterNumber)
          this.saveModelForm.controls.atpLabOptimized.setValue(element.labOptimized);
          this.saveModelForm.controls.canisterCapacity.setValue(element.canisterCapacity);
          this.saveModelForm.controls.highCapCapacity.setValue(element.highCapCapacity);

        }
      });
      let count = 0;
      let dataBindInterval = setInterval(() => {


        count++;
        if (count === 2) {
          this.dataSourceDevice.data = this.devicesModel
          clearInterval(dataBindInterval)
          this.ngxLoader.stop();
        }
      }, 500)

      setTimeout(() => {
        this.getInventoryByNdc();
      }, 0)
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        console.log(error);
        this.toastService.openToast(error.error.message === undefined ?
          'Something went wrong!!' : error.error.message,
          constants.ToastPanelType.error,
          2
        );
      })

    // Initial check when data is fetched
    const initialDrugType = this.saveModelForm.controls.drugClassificationType.value;
    this.toggleGTINField(initialDrugType);
  }

  onSourceChange(event: any): void {
    const selectedValue = event.value;
    this.dataSourceId = Number(selectedValue);
    this.saveModelForm.get('sourceId')?.setValue(this.dataSourceId);
    this.devicesModel = [];
    this.getDrugByndc();
    if (this.isCanisterDetails) {
      this.isCanisterDetails = !this.isCanisterDetails;
    }
    if (this.isSnapCanisterDetails) {
      this.isSnapCanisterDetails = !this.isSnapCanisterDetails;
    }
  }

  getUnit(search: string): void {
    this.isLoading = true;
    this.rpoToolService.getUnit(search).subscribe(
      (result) => {
        this.listofUnit = result.data;
        this.isLoading = false;
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.toastService.openToast(
          error.error.message ?? 'Something went wrong!!',
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }

  strengthValidator(control: AbstractControl): ValidationErrors | null {
    // Accept any value including empty string as valid strength
    return null;
  }

  loadAdditionalData() {
    this.rpoToolService.getDrugSourceByNDC(this.ndc).subscribe((response) => {
      this.dataSources = response.data;

    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(error.error.message ??
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })

  }

  getDistributor(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getDistributor(search)
      .subscribe(
        (result) => {
          this.listOfDistributor = result.data;
          this.isLoading = false;
          this.distributorId.setValidators([
            this.forbiddenNamesValidator(this.listOfDistributor)
          ]);
          this.distributorId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDosageForm(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getDosageForm(search)
      .subscribe(
        (result) => {
          this.listOfDosageForm = result.data;
          this.isLoading = false;
          this.dosageFormId.setValidators([
            this.forbiddenIdValidator(this.listOfDosageForm)
          ]);
          this.dosageFormId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getRoa(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getRouteOfAdministration(search)
      .subscribe(
        (result) => {
          this.listOfRoa = result.data;
          this.isLoading = false;
          this.routeOfAdminId.setValidators([
            this.forbiddenNamesValidator(this.listOfRoa)
          ]);
          this.routeOfAdminId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getNiosh() {
    this.rpoToolService
      .getNiosh()
      .subscribe(
        (result) => {
          this.listOfNiosh = result.data;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getManufacture(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getManufacture(search)
      .subscribe(
        (result) => {
          this.listOfManufacturer = result.data;
          this.isLoading = false;
          this.manufacturerId.setValidators([
            this.forbiddenNamesValidator(this.listOfManufacturer)
          ]);
          this.manufacturerId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDrugName(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getDrugName(search)
      .subscribe(
        (result) => {
          this.listOfDrugName = result.data;
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }



  getGenericName(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getGenericName(search)
      .subscribe(
        (result) => {
          this.listOfGenericName = result.data;
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }


  getColor(search) {
    this.rpoToolService
      .getColor(search)
      .subscribe(
        (result) => {
          this.listOfColor = result.data;
          this.allColors = this.listOfColor.map(color => String(color.label));
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getPackageType(value) {
    this.isLoading = true;
    this.rpoToolService
      .getPackageType(value)
      .subscribe(
        (result) => {
          this.listOfPackageType = result.data;
          this.isLoading = false;

          this.packageTypeId.setValidators([
            this.forbiddenNamesValidator(this.listOfPackageType)
          ]);
          this.packageTypeId.updateValueAndValidity();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getOtc() {
    this.ngxLoader.start();
    this.rpoToolService
      .getOtc()
      .subscribe({
        next: (result) => {
          this.listOfOTC = result.data;
          this.ngxLoader.stop();
        },
        error: (error) => this.errorHandlerService.handleError(error),
      });
  }


  getQuarantineReasonList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getQuarantineReasonList()
      .subscribe(
        (result) => {
          this.quarantineReasonList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getShapeList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getPillShapeList()
      .subscribe(
        (result) => {
          this.shapeList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDrugNonCountReasonList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getDrugNonCountReasonList()
      .subscribe(
        (result) => {
          this.listOfDnuReason = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  toggleCanisterDetails(isCanister: boolean, isSnapCanister: boolean) {
    // Check if canister details are already shown
    if (!this.isCanisterDetails) {
      this.GetDrugByClassificationIdAndNdc(isCanister, isSnapCanister);
    }
    // Toggle the state of canister details
    this.isCanisterDetails = !this.isCanisterDetails;
  }

  toggleSnapCanisterDetails(isCanister: boolean, isSnapCanister: boolean) {
    // Check if snap canister details are already shown
    if (!this.isSnapCanisterDetails) {
      this.GetDrugByClassificationIdAndNdc(isCanister, isSnapCanister);
    }
    // Toggle the state of snap canister details
    this.isSnapCanisterDetails = !this.isSnapCanisterDetails;
  }


  GetDrugByClassificationIdAndNdc(isCanisterDetails: boolean, isSnapCanisterDetails: boolean) {
    const formValue = this.saveModelForm.value;

    // Reset data source and show loader
    this.dataSource = [];
    this.ngxLoader.start();

    // Call the service to fetch data
    this.rpoToolService.GetDrugByClassificationIdAndNdc(formValue.classificationShapeId, this.ndc, formValue.sourceId)
      .subscribe(
        (response) => {
          this.ngxLoader.stop();  // Stop loader on response

          // Check if data exists
          if (response?.data) {
            const result = response.data;
            console.log(result)
            // Populate dataSource with response data
            this.dataSource = [
              { partType: 'DItems', part: result.passDItem, partNo: '' },
              { partType: 'Canister No', part: result.canisterRecipe, partNo: '' },
              { partType: 'Brush', part: result.snapBrushPart, partNo: result.snapBrush },
              { partType: 'Division Block', part: result.snapDivisionBlockPart, partNo: result.snapDivBlock },
              { partType: 'Gel Pad', part: result.snapGelPadPart, partNo: result.snapGelPadPartNo },
              { partType: 'Guide Block', part: result.snapGuideBlockPart, partNo: result.snapGuideBlock },
              { partType: 'Handle', part: result.handlePart, partNo: result.handlePartNo },
              { partType: 'Slot Location', part: result.slotLocationPart, partNo: result.slotLocationPartNo },
            ];

            // Update component state
            this.isCanisterDetails = isCanisterDetails;
            this.isSnapCanisterDetails = isSnapCanisterDetails;
          } else {
            // Handle empty data response
            this.toastService.openToast(
              response.message || 'No data found!',
              constants.ToastPanelType.warning,
              2
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();  // Ensure loader stops on error

          // Log the error for debugging
          console.error('Error fetching drug details:', error);

          // Display user-friendly error message
          this.toastService.openToast(
            error.error?.message || 'Something went wrong!',
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getRecommendedDrug() {

    const formValue = this.saveModelForm.value;
    if ((formValue.length == 0 || formValue.length == null) || (formValue.width == 0 || formValue.width == null) || (formValue.classificationShapeId == null || formValue.classificationShapeId == undefined || formValue.classificationShapeId == 0)) {
      this.toastService.openToast('Match not available... missing Length, width or shape',
        constants.ToastPanelType.warning,
        2
      );
      return;
    }
    this.ngxLoader.start();
    this.rpoToolService
      .getRecommendedDrug(formValue.length, formValue.width, formValue.thickness, formValue.pieceWeight, formValue.diagonal, formValue.classificationShapeId)
      .subscribe(
        (response) => {
          let result = response.data;
          this.canisterData = [];
          this.usersData = [];
          result.forEach((element: any) => {
            this.canisterData.push({
              canisterRecipe: this.saveModelForm.value.recommendationType == '1' ? element.canisterRecipe : element.snapRecipe,
              snapRecipe: element.snapRecipe,
              dItem: this.saveModelForm.value.recommendationType == '1' ? element.passDItem : element.snapDItem,
              matchLevel: element.matchLevel,
              medName: element.medName,
              canisters: [{
                length: element.length,
                width: element.width,
                diagonal: element.diagonal,
                pillType: element.pillType,
                pieceWeight: element.pieceWeight,
                thickness: element.thickness,
                snapBody: element.snapBody,
                snapBrush: element.snapBrush,
                snapBrushBlock: element.snapBrushBlock,
                snapDivBlock: element.snapDivBlock,
                snapGuideBlock: element.snapGuideBlock,
                slotLocation: element.slotLocation,
                divisionBlock: element.divisionBlock,
                brushId: element.brushId,
                gelPadId: element.gelPadId,
                handleIdId: element.handleIdId,
                guideBlock: element.guideBlock,
                weight: element.weight,
                handlePartNo: element.handlePartNo,
                handlePart: element.handlePart,
                slotLocationPartNo: element.slotLocationPartNo,
                slotLocationPart: element.slotLocationPart,
                snapDivisionBlockPart: element.snapDivisionBlockPart,
                snapGuideBlockPart: element.snapGuideBlockPart,
                snapGelPadPartNo: element.snapGelPadPartNo,
                snapGelPadPart: element.snapGelPadPart,
                snapBrushPart: element.snapBrushPart
              }]
            })
          });

          this.canisterData.forEach(user => {
            if (user.canisters && Array.isArray(user.canisters) && user.canisters.length) {
              this.usersData = [...this.usersData, { ...user, canisters: new MatTableDataSource(user.canisters) }];
            } else {
              this.usersData = [...this.usersData, user];
            }
          });
          this.dataSourceRecommendationDrug = new MatTableDataSource(this.usersData);
          this.isRecommendedShow = true;
          this.ngxLoader.stop();

        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getDrugByCanisterIdOrSnapCanisterId() {

    const formValue = this.saveModelForm.value;
    if ((formValue.length == 0 || formValue.length == null) || (formValue.width == 0 || formValue.width == null) || (formValue.classificationShapeId == null || formValue.classificationShapeId == undefined || formValue.classificationShapeId == 0)) {
      this.toastService.openToast('Match not available... missing Length, width or shape',
        constants.ToastPanelType.warning,
        2
      );
      return;
    }
    this.ngxLoader.start();
    this.rpoToolService
      .getRecommendedDrug(formValue.length, formValue.width, formValue.thickness, formValue.pieceWeight, formValue.diagonal, formValue.classificationShapeId)
      .subscribe(
        (response) => {
          let result = response.data;
          this.canisterData = [];
          this.usersData = [];
          result.forEach((element: any) => {
            this.canisterData.push({
              canisterRecipe: this.saveModelForm.value.recommendationType == '1' ? element.canisterRecipe : element.snapRecipe,
              snapRecipe: element.snapRecipe,
              dItem: this.saveModelForm.value.recommendationType == '1' ? element.passDItem : element.snapDItem,
              matchLevel: element.matchLevel,
              medName: element.medName,
              canisters: [{
                length: element.length,
                width: element.width,
                diagonal: element.diagonal,
                pillType: element.pillType,
                pieceWeight: element.pieceWeight,
                thickness: element.thickness,
                snapBody: element.snapBody,
                snapBrush: element.snapBrush,
                snapBrushBlock: element.snapBrushBlock,
                snapDivBlock: element.snapDivBlock,
                snapGuideBlock: element.snapGuideBlock,
                slotLocation: element.slotLocation,
                divisionBlock: element.divisionBlock,
                brushId: element.brushId,
                gelPadId: element.gelPadId,
                handleIdId: element.handleIdId,
                guideBlock: element.guideBlock,
                weight: element.weight,
                handlePartNo: element.handlePartNo,
                handlePart: element.handlePart,
                slotLocationPartNo: element.slotLocationPartNo,
                slotLocationPart: element.slotLocationPart,
                snapDivisionBlockPart: element.snapDivisionBlockPart,
                snapGuideBlockPart: element.snapGuideBlockPart,
                snapGelPadPartNo: element.snapGelPadPartNo,
                snapGelPadPart: element.snapGelPadPart,
                snapBrushPart: element.snapBrushPart

              }]
            })
          });

          this.canisterData.forEach(user => {
            if (user.canisters && Array.isArray(user.canisters) && user.canisters.length) {
              this.usersData = [...this.usersData, { ...user, canisters: new MatTableDataSource(user.canisters) }];
            } else {
              this.usersData = [...this.usersData, user];
            }
          });
          this.dataSourceRecommendationDrug = new MatTableDataSource(this.usersData);
          this.isRecommendedShow = true;
          this.ngxLoader.stop();

        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getClassificationShape() {
    this.ngxLoader.start();
    this.rpoToolService
      .getClassificationShape()
      .subscribe(
        (result) => {
          this.listOfClassificationShape = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getInventoryByNdc() {
    this.ngxLoader.start();
    this.rpoToolService
      .getInventoryByNDC(this.drugCharacteristicsModel.drugId)
      .subscribe(

        (response) => {
          let result = response.data
          this.inventoryList = [];
          result.forEach((element: any) => {
            this.inventoryList.push({
              id: element.id,
              inventoryNumber: element.id,
              addedDate: element.date,
              owner: element.changedDate,
              inventoryQuantity: element.quantity,
              lastChangedDate: element.changedDate,
              isDestroyed: element.destroyed,
              destroyDate: element.destroyedDate,
              destroyedBy: element.destroyedBy,
              destroyedComments: element.destroyedComments,
              price: element.price,
              source: element.source,
              sourceAddress: element.sourceAddress,
              sourcePhone: element.sourcePhone,
              sourceEmail: element.sourceEmail,
              comments: element.comments,
            });
          });

          this.ngxLoader.stop();

        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  openImportWizardImageSlide() {

    const dialogRef = this.dialog.open(ImportWizardImageSlideComponent, {
      backdropClass: ['mdDialog'],
      disableClose: true,
      data: { ndc: this.drugCharacteristicsModel.drugId, dataSource: this.dataSourceId, editPage: true, drugId: this.drugId }
    });
  }


  saveCanister() {
    if (this.saveModelForm.value.recommendationType == 1) {
      this.passModel.canisterId = this.assignCanisterModel.canisterRecipe;
    }
    else if (this.saveModelForm.value.recommendationType == 2) {
      this.passModel.snapCanisterId = this.assignCanisterModel.snapRecipe;
    }
    this.isRecommendedShow = false;


  }

  cancelSletectedCanisterId() {
    this.isRecommendedShow = false;
    if (this.canisterId) {
      this.passModel.canisterId = this.canisterId;
    }
    if (this.snapCanisterId) {
      this.passModel.snapCanisterId = this.snapCanisterId;
    }
    this.assignCanisterModel = {};
  }

  updateDrug() {
    if (!this.saveModelForm?.valid) {
      // Check for specific PNC Reason validation errors
      const formValue = this.saveModelForm.getRawValue();
      const pncErrors: string[] = [];
      
      if (formValue.maxDrugStatus === 'PERMANENT NON-COUNT' && !this.hasPncSelection(formValue.maxPnr)) {
        pncErrors.push('Max');
      }
      if (formValue.passDrugStatus === 'PERMANENT NON-COUNT' && !this.hasPncSelection(formValue.passPnr)) {
        pncErrors.push('PASS');
      }
      if (formValue.atpDrugStatus === 'PERMANENT NON-COUNT' && !this.hasPncSelection(formValue.atpPnr)) {
        pncErrors.push('ATP');
      }
      if (formValue.synmedDrugStatus === 'PERMANENT NON-COUNT' && !this.hasPncSelection(formValue.synmedPnr)) {
        pncErrors.push('Synmed');
      }
      
      if (pncErrors.length > 0) {
        this.openAlertWindow('Validation Error', `PNC Reason is required for ${pncErrors.join(', ')} when Drug Status is set to Permanent Non-Count.`);
      }
      return;
    }
    if (!(this.saveModelForm.get('length').value >= this.saveModelForm.get('width').value && this.saveModelForm.get('width').value >= this.saveModelForm.get('thickness').value)) {
      this.openAlertWindow('Warning', 'Invalid input: Length must be greater than Width, and Width must be greater than Thickness')
      return;
    }
    if (this.saveModelForm.get('quarantineId').value != 6) {
      this.drugInforUpdateApi()
    }
    else if (this.saveModelForm.get('quarantineId').value == 6) {
      this.openAlertWindow('Warning', 'Are you sure you want to set this as a permanent quarantine drug?')
    }

  }
  drugInforUpdateApi(closeWindow: boolean = true) {
    const formValue = this.saveModelForm.getRawValue();
    console.log(formValue.scheduleId, "formvalue.ScheduleId");
    const strengthInput = formValue.strength?.trim() || ''; // e.g. "3 Gram"
    const [strengthValue, unitLabel] = strengthInput.split(' ');
    const selectedMaxPnr = this.resolvePnrControlValue(formValue.maxPnr);
    const selectedPassPnr = this.resolvePnrControlValue(formValue.passPnr);
    const selectedAtpPnr = this.resolvePnrControlValue(formValue.atpPnr);
    const selectedSynmedPnr = this.resolvePnrControlValue(formValue.synmedPnr);
    
    // Convert PNR values to strings for API compatibility
    const maxPnrString = selectedMaxPnr !== null && selectedMaxPnr !== undefined ? String(selectedMaxPnr) : null;
    const passPnrString = selectedPassPnr !== null && selectedPassPnr !== undefined ? String(selectedPassPnr) : null;
    const atpPnrString = selectedAtpPnr !== null && selectedAtpPnr !== undefined ? String(selectedAtpPnr) : null;
    const synmedPnrString = selectedSynmedPnr !== null && selectedSynmedPnr !== undefined ? String(selectedSynmedPnr) : null;
    
    const effectivePncSelection = this.getEffectivePncSelection(formValue);
    const effectivePncReason = effectivePncSelection?.label || '';
    const resolvedDnuReason = effectivePncReason
      ? (effectivePncSelection?.matchedOption?.label?.toString().trim() || effectivePncReason)
      : null;
    const resolvedNonCountReasonId = effectivePncSelection?.reasonId ?? null;

    // Match unit label to unitId from listofUnit
    const matchedUnit = this.listofUnit.find(
      unit => unit.label.toLowerCase() === unitLabel?.toLowerCase()
    );

    this.drugUpdateModel = {
      classificationShapeId: formValue.classificationShapeId,
      length: formValue.length,
      dnumber: formValue.dnumber && formValue.dnumber.split("D") && formValue.dnumber.split("D")[1],
      width: formValue.width,
      thickness: formValue.thickness,
      ridgeThickness: formValue.ridgeThickness,
      weight: formValue.pieceWeight,
      diagonal: formValue.diagonal,
      ndc: this.drugCharacteristicsModel.drugId,
      packageBarcode: formValue.packageBarcode && formValue.packageBarcode.trim() !== '' ? formValue.packageBarcode : null,
      packageBarcode2d: formValue.packageBarcode2d && formValue.packageBarcode2d.trim() !== '' ? formValue.packageBarcode2d : null,
      packageThirtyDramCapacity: formValue.packageThirtyDramCapacity,
      coatingId: formValue.coatingId,
      packageImprint1: formValue.packageImprint1,
      packageImprint2: formValue.packageImprint2,
      color: this.selectedColors.join(','),
      scoringId: formValue.scoringId,
      maxThirtyDramDnu: formValue.maxThirtyDramDnu,
      maxDoNotUse: formValue.maxDoNotUse === '' || formValue.maxDoNotUse === null || formValue.maxDoNotUse === undefined
        ? 0
        : formValue.maxDoNotUse,
      maxDrugStatus: formValue.maxDrugStatus,
      maxPnr: maxPnrString,
      maxCellHeight: formValue.maxCellHeight,
      maxCellWidth: formValue.maxCellWidth,
      maxBaffle: formValue.maxBaffle,
      maxPressure: formValue.maxPressure,
      atpDrugStatus: formValue.atpDrugStatus,
      atpTcgDiameter: formValue.atpTcgDiameter,
      atpTcgPillType: formValue.atpTcgPillType,
      atpTcgPillVolume: formValue.atpTcgPillVolume,
      atpTcgT1: formValue.atpTcgT1,
      atpTcgT2: formValue.atpTcgT2,
      atpCanisterNumber: formValue.atpCanisterNumber,
      atpLabOptimized: formValue.atpLabOptimized,
      atpPnr: atpPnrString,
      synMedPnr: synmedPnrString,
      synmedIsLabOptimized: formValue.synmedLabOptimized,
      passIsLabOptimized: formValue.passLabOptimized,
      maxIsLabOptimized: formValue.maxLabOptimized,
      atpIsLabOptimized: formValue.atpLabOptimized,
      passDrugStatus: formValue.passDrugStatus,
      passPnr: passPnrString,
      passCanisterNumber: this.passModel.canisterId,
      passSnapCanisterNumber: this.passModel.snapCanisterId,

      fragileFlag: formValue.fragileFlag,
      toggleFlag: formValue.toggle,
      preferredToggleFlag: formValue.preferredToggle,

      source: this.source,
      id: this.drugId,
      schemaName: this.schemaName,
      distributorId: formValue.distributorId,
      packageSize: formValue.packageSize,
      packageDepth: formValue.packageDepth,
      packageHeight: formValue.packageHeight,
      packageTypeId: formValue.packageTypeId === "" ? null : formValue.packageTypeId,
      packageWidth: formValue.packageWidth,
      countryCodeId: formValue.country,
      drugNumberTypeId: formValue.drugClassificationType,
      oralSolid: formValue.oralSolid,
      synmedDrugStatus: formValue.synmedDrugStatus,
      cellCapacity: formValue.cellCapacity,
      superCellCapacity: formValue.superCellCapacity,
      canisterCapacity: formValue.canisterCapacity,
      highCapCapacity: formValue.highCapCapacity,
      quarantineId: formValue.quarantineId,
      shapeId: formValue.shapeId,

      dnuReason: effectivePncReason ? resolvedDnuReason : null,
      nonCountReasonId: effectivePncReason ? (resolvedNonCountReasonId ?? formValue.nonCountReasonId ?? null) : null,
      largePipetteDropHeight: formValue.largePipetteDropHeight,
      smallPipetteDropHeight: formValue.smallPipetteDropHeight,

      massIndex: formValue.massIndex,
      preferredMassIndex: formValue.preferredMassIndex,

      lidHoleSize: formValue.lidHole,
      preferredLidHoleSize: formValue.preferredLidHoleSize,

      lidVolcanic: formValue.lidVolcanic,
      preferredLidVolcanic: formValue.preferredLidVolcanic,

      containerSize: formValue.containerSize,
      preferredContainerSize: formValue.preferredContainerSize,

      pipetteSize: formValue.pipetteSize,
      preferredPipetteSize: formValue.preferredPipetteSize,

      smallCanisterCapacity: formValue.smallCanisterCapacity,
      largeCanisterCapacity: formValue.largeCanisterCapacity,
      //characteristics
      genericName: formValue.genericName,
      strength: strengthValue,
      unitId: matchedUnit?.value || null,
      drugId: formValue.drugId,
      active: formValue.active,
      scheduleId: formValue.scheduleId,
      manufacturer: formValue.manufacturer,
      routeOfAdminId: formValue.routeOfAdminId,
      dosageFormId: formValue.dosageFormId,
      otc: formValue.otc,
      dosageForm: formValue.dosageForm,
      niosh: formValue.niosh && formValue.niosh.trim() !== '' ? formValue.niosh : null,
      antibiotics: formValue.antibiotics,
      unitOfUse: formValue.unitOfUse,
      unitDose: formValue.unitDose,
      updated: formValue.updatedate,
      storageConditions: formValue.storageConditions && formValue.storageConditions.trim() !== '' ? formValue.storageConditions : null,
      gpi: formValue.gpi,
      gcn: formValue.gcn,
      shape: formValue.shape,
      drugName: formValue.drugNameId,
      manufacturerId: formValue.manufacturerId,
      drugNameId: 1,
      drugStatusId: formValue.drugStatusId,
      species: formValue.species,
      otcId: formValue.otcId,
      isSuperCellOnly: formValue.isSuperCellOnly,
      drugNumberFormatId: formValue.drugNumberFormat,
      gtin: this.saveModelForm.get('gtin')?.value
    };
    this.ngxLoader.start();
    this.rpoToolService
      .updateDrug(this.drugUpdateModel)
      .subscribe(
        (result) => {
          this.ngxLoader.stop();
          if (result.statusCode === 200 && closeWindow) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.done,
              2
            );
            setTimeout(() => {
              this.clearFormData();
            }, 500)

          } else if (closeWindow) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.error,
              2
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  private hasPncSelection(value: any): boolean {
    return value !== null && value !== undefined && `${value}`.trim() !== '';
  }

  private isPermanentNonCount(status: any): boolean {
    return (status ?? '').toString().trim().toUpperCase() === 'PERMANENT NON-COUNT';
  }

  private parseReasonId(value: any): number | null {
    if (value === null || value === undefined || typeof value === 'boolean') {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private resolvePnrOption(rawPnr: any): DropDown | undefined {
    if (!this.hasPncSelection(rawPnr)) {
      return undefined;
    }

    const normalized = `${rawPnr}`.trim().toLowerCase();
    return this.listOfPnr.find((reason) => {
      const reasonLabel = reason?.label?.toString().trim().toLowerCase();
      const reasonValue = reason?.value?.toString().trim().toLowerCase();
      return reasonLabel === normalized || reasonValue === normalized;
    });
  }

  private getEffectivePncSelection(formValue: any): { value: any; label: string | null; reasonId: number | null; matchedOption?: DropDown } | null {
    const pncSelections = [
      { controlName: 'maxPnr', status: formValue.maxDrugStatus, value: formValue.maxPnr },
      { controlName: 'passPnr', status: formValue.passDrugStatus, value: formValue.passPnr },
      { controlName: 'atpPnr', status: formValue.atpDrugStatus, value: formValue.atpPnr },
      { controlName: 'synmedPnr', status: formValue.synmedDrugStatus, value: formValue.synmedPnr },
    ].filter((item) => this.isPermanentNonCount(item.status) && this.hasPncSelection(item.value));

    const effectiveSelection =
      pncSelections.find((item) => this.saveModelForm.get(item.controlName)?.dirty) ||
      pncSelections.find((item) => !this.saveModelForm.get(item.controlName)?.disabled) ||
      pncSelections[0] ||
      null;

    if (!effectiveSelection) {
      return null;
    }

    const matchedOption = this.resolvePnrOption(effectiveSelection.value);
    const resolvedReasonId = this.parseReasonId(effectiveSelection.value) ?? this.parseReasonId(matchedOption?.value);

    return {
      value: effectiveSelection.value,
      label: this.resolvePnrLabel(effectiveSelection.value),
      reasonId: resolvedReasonId,
      matchedOption
    };
  }
  getPassDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getPassDrugStatus()
      .subscribe(
        (result) => {
          this.listOfPASSDrugStatus = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getMaxDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getMaxDrugStatus()
      .subscribe(
        (result) => {
          this.listOfMAXDrugStatus = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }



  getSynmedDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getSynmedDrugStatus()
      .subscribe(
        (result) => {
          this.listOfSynmedDrugStatus = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  private resolvePnrControlValue(rawPnr: any): string | number | null {
    if (rawPnr === null || rawPnr === undefined || `${rawPnr}`.trim() === '') {
      return null;
    }

    const normalized = `${rawPnr}`.trim().toLowerCase();
    const matched = this.listOfPnr.find((reason) => {
      const reasonLabel = reason?.label?.toString().trim().toLowerCase();
      const reasonValue = reason?.value?.toString().trim().toLowerCase();
      return reasonLabel === normalized || reasonValue === normalized;
    });

    return (matched ? matched.value : rawPnr) as string | number;
  }

  private resolvePnrLabel(rawPnr: any): string | null {
    if (rawPnr === null || rawPnr === undefined || `${rawPnr}`.trim() === '') {
      return null;
    }

    const normalized = `${rawPnr}`.trim().toLowerCase();
    const matched = this.listOfPnr.find((reason) => {
      const reasonLabel = reason?.label?.toString().trim().toLowerCase();
      const reasonValue = reason?.value?.toString().trim().toLowerCase();
      return reasonLabel === normalized || reasonValue === normalized;
    });

    return matched?.label?.toString().trim() || `${rawPnr}`.trim();
  }

  private normalizePnrControls() {
    const pnrFields = ['maxPnr', 'passPnr', 'atpPnr', 'synmedPnr'];
    pnrFields.forEach((fieldName) => {
      const control = this.saveModelForm.get(fieldName);
      if (!control) {
        return;
      }

      const normalizedValue = this.resolvePnrControlValue(control.value);
      if (normalizedValue !== control.value) {
        control.setValue(normalizedValue, { emitEvent: false });
      }
    });

    this.updateNonCountReasonIdFromPnrSelection();
  }

  private resolvePnrReasonId(rawPnr: any): number | null {
    if (!this.hasPncSelection(rawPnr)) {
      return null;
    }

    const matched = this.resolvePnrOption(rawPnr);
    return this.parseReasonId(rawPnr) ?? this.parseReasonId(matched?.value);
  }

  private updateNonCountReasonIdFromPnrSelection() {
    if (!this.saveModelForm) {
      return;
    }

    const formValue = this.saveModelForm.getRawValue();
    const effectiveSelection = this.getEffectivePncSelection(formValue);
    const resolvedNonCountReasonId = effectiveSelection ? this.resolvePnrReasonId(effectiveSelection.value) : null;
    this.saveModelForm.get('nonCountReasonId')?.setValue(resolvedNonCountReasonId, { emitEvent: false });
  }

  PnrDropdownDisableForAtp() {
    const atpDrugStatus = this.saveModelForm.get('atpDrugStatus')?.value;
    const pnrAtpControl = this.saveModelForm.get('atpPnr');

    if (atpDrugStatus === 'PERMANENT NON-COUNT') {
      pnrAtpControl?.enable();
      pnrAtpControl?.setValidators([Validators.required]);
    } else {
      pnrAtpControl?.setValue(null);
      pnrAtpControl?.clearValidators();
      pnrAtpControl?.disable();
    }
    pnrAtpControl?.updateValueAndValidity();
  }

  PnrDropdownDisableForPass() {
    const passDrugStatus = this.saveModelForm.get('passDrugStatus')?.value;
    const passPnr = this.saveModelForm.get('passPnr');

    if (passDrugStatus === 'PERMANENT NON-COUNT') {
      passPnr?.enable();
      passPnr?.setValidators([Validators.required]);
    } else {
      passPnr?.setValue(null);
      passPnr?.clearValidators();
      passPnr?.disable();
    }
    passPnr?.updateValueAndValidity();
  }

  PnrDropdownDisableForMax() {
    const maxDrugStatus = this.saveModelForm.get('maxDrugStatus')?.value;
    const maxPnr = this.saveModelForm.get('maxPnr');

    if (maxDrugStatus === 'PERMANENT NON-COUNT') {
      maxPnr?.enable();
      maxPnr?.setValidators([Validators.required]);
    } else {
      maxPnr?.setValue(null);
      maxPnr?.clearValidators();
      maxPnr?.disable();
    }
    maxPnr?.updateValueAndValidity();
  }

  PnrDropdownDisableForSynmed() {
    const synmedDrugStatus = this.saveModelForm.get('synmedDrugStatus')?.value;
    const synmedPnr = this.saveModelForm.get('synmedPnr');

    if (synmedDrugStatus === 'PERMANENT NON-COUNT') {
      synmedPnr?.enable();
      synmedPnr?.setValidators([Validators.required]);
    } else {
      synmedPnr?.setValue(null);
      synmedPnr?.clearValidators();
      synmedPnr?.disable();
    }
    synmedPnr?.updateValueAndValidity();
  }


  getAtpDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getAtpDrugStatus()
      .subscribe(
        (result) => {
          this.listOfATPDrugStatus = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getPnrList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getPnrList()
      .subscribe(
        (result) => {
          this.listOfPnr = result.data;
          this.normalizePnrControls();
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }


  clearFormData() {

    this.saveModelForm.reset();
    this.closeDialog(true);
  }
  closeDialog(response: boolean) {
    this.dialogRef.close({ event: 'close', data: response })
  }
  hasThirtyDramCapacityRequiredValues(): boolean {
    try {
      const fields = ['length', 'width', 'thickness', 'classificationShapeId'];
      return fields.every(field => {
        const control = this.saveModelForm.get(field);
        const value = control?.value;
        return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
      });
    } catch (error) {
      console.error('Error checking ThirtyDramCapacity values:', error);
      return false;
    }
  }
  hasSynmedRequiredValues(): boolean {
    try {
      const fields = ['length', 'width', 'thickness', 'pieceWeight', 'packageThirtyDramCapacity'];
      return fields.every(field => {
        const control = this.saveModelForm.get(field);
        const value = control?.value;
        return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
      });
    } catch (error) {
      console.error('Error checking Synmed values:', error);
      return false;
    }
  }
  hasMaxRequiredValues(): boolean {
    try {
      // The MAX calculation requires these five inputs.
      const fields = ['pieceWeight', 'packageThirtyDramCapacity', 'width', 'thickness', 'classificationShapeId'];
      return fields.every(field => {
        const control = this.saveModelForm.get(field);
        const value = control?.value;
        return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
      });
    } catch (error) {
      console.error('Error checking MAX values:', error);
      return false;
    }
  }



  calculateThirtyDramCapacityValues(): void {
    if (!this.saveModelForm || this.isThirtyDramCapacityCalculating) return;
    if (!this.hasThirtyDramCapacityRequiredValues()) return;

    this.isThirtyDramCapacityCalculating = true;

    // Gather the five core input values from the form.
    const length = Number(this.saveModelForm.get('length')?.value);
    const widthInput = Number(this.saveModelForm.get('width')?.value);
    const thickness = Number(this.saveModelForm.get('thickness')?.value);
    const classificationShapeId = Number(this.saveModelForm.get('classificationShapeId')?.value);

    const request = {
      Length: length,
      Width: widthInput,
      Thickness: thickness,
      ClassificationShapeId: classificationShapeId
    };

    console.log('Thirty Dram Capacity calculation request:', request);

    this.rpoToolService.calculateThirtyDramCapacityValues(request).subscribe({
      next: (response) => {
        console.log('Thirty Dram Capacity calculation response:', response);
        if (response.succeed && this.saveModelForm) {
          // Patch the form controls with the calculated values from the API.
          this.saveModelForm.patchValue({
            packageThirtyDramCapacity: response.data,          // API 30dram capacity → packageThirtyDramCapacity
          }, { emitEvent: false });
        }
      },
      error: (error) => {
        console.error('Error calculating Thirty Dram Capacity values:', error);
        this.toastService.openToast('Error calculating Thirty Dram Capacity values', constants.ToastPanelType.error, 2);
      },
      complete: () => {
        this.isThirtyDramCapacityCalculating = false;
      }
    });
  }


  calculateMaxValues(): void {
    if (!this.saveModelForm || this.isMaxCalculating) return;
    if (!this.hasMaxRequiredValues()) return;

    this.isMaxCalculating = true;

    // Gather the five core input values from the form.
    const weight = Number(this.saveModelForm.get('pieceWeight')?.value);
    const thirtyDramCapacity = Number(this.saveModelForm.get('packageThirtyDramCapacity')?.value);
    const widthInput = Number(this.saveModelForm.get('width')?.value);
    const thickness = Number(this.saveModelForm.get('thickness')?.value);
    const classificationShapeId = Number(this.saveModelForm.get('classificationShapeId')?.value);

    const request = {
      Weight: weight,
      ThirtyDramCapacity: thirtyDramCapacity,
      Width: widthInput,
      Thickness: thickness,
      ClassificationShapeId: classificationShapeId
    };

    console.log('MAX calculation request:', request);

    this.rpoToolService.calculateMaxValues(request).subscribe({
      next: (response) => {
        console.log('MAX calculation response:', response);
        if (response.succeed && this.saveModelForm) {
          // Patch the form controls with the calculated values from the API.
          this.saveModelForm.patchValue({
            maxCellHeight: response.data.height,          // API height → maxCellHeight
            maxCellWidth: response.data.width,              // API width  → maxCellWidth
            maxPressure: response.data.pressure,            // API pressure → maxPressure
            maxBaffle: response.data.baffle,                // API baffle → maxBaffle
            cellCapacity: response.data.cellCapacity,       // API cellCapacity
            superCellCapacity: response.data.superCellCapacity // API superCellCapacity
          }, { emitEvent: false });
        }
      },
      error: (error) => {
        console.error('Error calculating MAX values:', error);
        this.toastService.openToast('Error calculating MAX values', constants.ToastPanelType.error, 2);
      },
      complete: () => {
        this.isMaxCalculating = false;
      }
    });
  }


  calculateSynmedValues() {
    if (!this.saveModelForm || this.isSynmedCalculating) return;

    try {
      const length = Number(this.saveModelForm.get('length')?.value);
      const width = Number(this.saveModelForm.get('width')?.value);
      const thickness = Number(this.saveModelForm.get('thickness')?.value);
      const pieceWeight = Number(this.saveModelForm.get('pieceWeight')?.value);
      const thirtyDramCapacity = Number(this.saveModelForm.get('packageThirtyDramCapacity')?.value);

      if ([length, width, thickness, pieceWeight, thirtyDramCapacity].some(v => isNaN(v))) {
        return;
      }

      // Start loader
      this.isSynmedCalculating = true;

      const request = {
        Length: length,
        Width: width,
        Thickness: thickness,
        PieceWeight: pieceWeight,
        ThirtyDramCapacity: thirtyDramCapacity
      };

      console.log('Synmed calculation request:', request);

      this.rpoToolService.calculateSynmedValues(request).subscribe({
        next: (response) => {
          console.log('Synmed calculation response:', response);
          if (response.succeed && this.saveModelForm) {
            this.saveModelForm.patchValue({
              preferredLidHoleSize: response.data.preferredLidHoleSize,
              preferredLidVolcanic: response.data.preferredLidVolcanic,
              preferredPipetteSize: response.data.preferredPipetteSize,
              preferredContainerSize: response.data.preferredContainerSize,
              useBothCanisters: response.data.useBothCanisters,
              lidVolcanic: response.data.lidVolcanic,
              massIndex: response.data.massIndex,
              preferredMassIndex: response.data.preferredMassIndex,
              massIndexConcat: response.data.massIndexConcat,
              pipetteDropHeight: response.data.pipetteDropHeight,
              smallPipetteDropHeight: response.data.smallPipetteDropHeight,
              largePipetteDropHeight: response.data.largePipetteDropHeight,
              smallCanisterCapacity: response.data.smallContainerCapacity,
              largeCanisterCapacity: response.data.largeContainerCapacity
            }, { emitEvent: false });
          }
        },
        error: (error) => {
          console.error('Synmed calculation error:', error);
          this.toastService.openToast(
            'Error calculating Synmed values',
            constants.ToastPanelType.error,
            2
          );
        },
        complete: () => {
          this.isSynmedCalculating = false;
        }
      });
    } catch (error) {
      console.error('Error in calculateSynmedValues:', error);
      this.isSynmedCalculating = false;
    }
  }

  calculateTcgValues() {
    if (!this.saveModelForm || this.isTcgCalculating) return;

    try {
      const thirtyDramCapacity = Number(this.saveModelForm.get('packageThirtyDramCapacity')?.value);

      if (isNaN(thirtyDramCapacity)) return;

      this.isTcgCalculating = true;
      const request = {
        ThirtyDramCapacity: thirtyDramCapacity
      };

      this.rpoToolService.calculateTcgValues(request).subscribe({
        next: (response) => {
          if (response.succeed && this.saveModelForm) {
            this.saveModelForm.patchValue({
              canisterCapacity: response.data.canisterCapacity,
              highCapCapacity: response.data.highCapCanisterCapacity
            }, { emitEvent: false });
          }
        },
        error: (error) => {
          console.error('TCG calculation error:', error);
          this.toastService.openToast(
            'Error calculating TCG values',
            constants.ToastPanelType.error,
            2
          );
        },
        complete: () => {
          this.isTcgCalculating = false;
        }
      });
    } catch (error) {
      console.error('Error in calculateTcgValues:', error);
      this.isTcgCalculating = false;
    }
  }
  setupFormWatchers() {
    const pncSyncFields = ['maxPnr', 'passPnr', 'atpPnr', 'synmedPnr', 'maxDrugStatus', 'passDrugStatus', 'atpDrugStatus', 'synmedDrugStatus'];
    pncSyncFields.forEach((field) => {
      this.saveModelForm.get(field)?.valueChanges.subscribe(() => {
        this.updateNonCountReasonIdFromPnrSelection();
      });
    });

    this.updateNonCountReasonIdFromPnrSelection();

    setTimeout(() => {
      // ThirtyDramCapacity Watcher - use 4 fields for Thirty Dram Capacity Calculation
      const thirtyDramCapacityCalculationFields = ['length', 'width', 'thickness', 'classificationShapeId'];
      thirtyDramCapacityCalculationFields.forEach(field => {
        this.saveModelForm.get(field)?.valueChanges
          .pipe(
            debounceTime(500)
          )
          .subscribe(() => {
            if (this.hasThirtyDramCapacityRequiredValues()) {
              console.log("inside thirtyDramCapacityCalculationFields");
              this.calculateThirtyDramCapacityValues();
            }
          });
      });
    }, 1000);
  }

  calculateTcgMaxSynmedValues() {

    // Synmed Calculation
    if (this.hasSynmedRequiredValues()) {
      this.calculateSynmedValues();
    }

    // TCG Calculation
    const value = this.saveModelForm.get('packageThirtyDramCapacity')?.value;
    if (value) {
      this.calculateTcgValues();
    }

    // MAX Calculation
    if (this.hasMaxRequiredValues()) {
      this.calculateMaxValues();
    }
  }

  openAlertWindow(title: string, message: string, btnCancel: string = 'Cancel', btnConfirm: string = 'Confirm'): any {
    let output = false;
    const dialogRef = this.dialog.open(ImportWizardAlertComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: title,
        bodyMessage: message,
        bodyMessage2: "",
        cancelBtnText: btnCancel,
        confirmBtnText: btnConfirm,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === true) {
        this.drugInforUpdateApi()
      } else {
        console.log("Cancle", result);
        output = result.data;
      }
    });
    return output;
  }


  showResolveButton(): boolean {
    const q_reason = this.drugCharacteristicsModel.quarantineReason;
    return this.drugCharacteristicsModel.quarantined && q_reason !== "Removed From Quarantine" && q_reason !== "Permanent Quarantine"
      && q_reason !== "Unvalidated" && q_reason !== "Test Drug" && !this.isQuarantineDrugAlreadyResolved;
  }


  openMergeQuarantinedDrugImportWizard() {
    const dialogRef = this.dialog.open(MergeQuarantineDrugWizardComponent, {
      backdropClass: ['lpDialog'],
      disableClose: true,
      data: {
        quarantineDrugNumber: this.drugAllInfo.characteristics.drugId,
        drugName: this.drugCharacteristicsModel.drugName,
        strength: this.drugCharacteristicsModel.strength,
        unit: this.drugCharacteristicsModel.unit,
        drugAllInfo: this.drugAllInfo,
        quarantineReason: this.drugCharacteristicsModel.quarantineReason,
        title: 'Merge Quarantine Drug',
        cancelBtnText: "Cancel",
        confirmBtnText: "Ok",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("result", result);
    });
  }

  AttributeValidation(controlName: string, event: any) {
    const value = event.target.value;
    //const control = this.form.get(controlName);
    console.log(value);
    if (controlName === 'maxCellHeight') {
      if (!this.validHeights.includes(parseFloat(value))) {
        this.toastService.openToast("Invalid Max Cell Height",
          constants.ToastPanelType.error,
          2
        );
        this.saveModelForm.controls.maxCellHeight.setValue(null);
      }
    }
    else if (controlName === 'maxCellWidth') {
      if (!this.validWidths.includes(value)) {
        this.toastService.openToast("Invalid Max Cell Width! Please enter a value like A.00, A.25, etc.",
          constants.ToastPanelType.error,
          2
        );
        this.saveModelForm.controls.maxCellWidth.setValue('');
      }
    }
    else if (controlName === 'maxBaffle') {
      if (!this.validBaffles.includes(parseInt(value))) {
        this.toastService.openToast("Invalid Baffle value.",
          constants.ToastPanelType.error,
          2
        );
        this.saveModelForm.controls.maxBaffle.setValue(null);
      }
    }
    else if (controlName === 'maxPressure') {
      if (!this.validPressures.includes(parseInt(value))) {
        this.toastService.openToast("Invalid Pressure value.",
          constants.ToastPanelType.error,
          2
        );
        this.saveModelForm.controls.maxPressure.setValue(null);
      }
    }
  }

  getScheduleList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getScheduleList()
      .subscribe(
        (result) => {
          this.scheduleList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getUnitList() {
    this.ngxLoader.start();
    this.rpoToolService
      .getUnit('')
      .subscribe(
        (result) => {
          this.unitList = result.data;
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  getCommonDrugStatus() {
    this.ngxLoader.start();
    this.rpoToolService
      .getCommonDrugStatus()
      .subscribe(
        (result) => {
          this.listOfDrugStatus = result.data; // Set default value to the Active option id value
          this.ngxLoader.stop();
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  openAleftWizardForValidateDrug(caseNo: any) {

    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: 'DCR Case Close Warning',
        bodyMessage: 'Are you sure to close this Sales force DCR Case ?',
        bodyMessage2: "Case Number : " + caseNo,
        cancelBtnText: "Cancel",
        confirmBtnText: "Ok",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("result", result);
      if (result.data) {
        this.closeDcr(caseNo);
      }
    });
  }

  closeDcr(caseNo: any) {
    this.dcrUpdateModel = {
      status: 'close'
    };
    this.ngxLoader.start();
    this.rpoToolService
      .updateDcr(caseNo, this.dcrUpdateModel)
      .subscribe(
        (result) => {
          this.ngxLoader.stop();
          if (result.statusCode === 200) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.done,
              2
            );
            this.isDcrClosed = true;
          } else {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.error,
              2
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }
  onCanisterEditSelectionChange() {
    this.passModel.canisterId = this.canisterId;
    this.passModel.snapCanisterId = this.snapCanisterId;
    this.editCanSelection = this.saveModelForm.value.canisterEditSelection;
    if (this.editCanSelection == 2) {
      this.getRecommendedDrug();
      this.saveModelForm.get('canisterManual')?.setValue('');
      this.saveModelForm.get('snapCanisterManual')?.setValue('');

    } else {
      this.isRecommendedShow = false;
    }
  }

  onCanisterSwap() {
    if (this.editCanSelection == 2) {
      this.getRecommendedDrug();
    }
  }

  onCanisterDigitInput(event: any): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '').slice(0, 4);
    input.value = digits;
    this.saveModelForm.get('canisterManual')?.setValue(digits, { emitEvent: false });

    if (digits.length === 4) {
      this.passModel.canisterId = '801-' + digits;
    } else {
      this.passModel.canisterId = this.canisterId;
    }
  }

  onSnapCanDigitInput(event: any): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '').slice(0, 4);
    input.value = digits;
    this.saveModelForm.get('snapCanisterManual')?.setValue(digits, { emitEvent: false });

    if (digits.length === 4) {
      this.passModel.snapCanisterId = '801-' + digits;
    } else {
      this.passModel.snapCanisterId = this.snapCanisterId;
    }

  }

  toggleGTINField(drugType: number) {
    const isUPC = drugType === 6 || drugType === 7; // 6 = UPC 10, 7 = UPC 12
    const gtinControl = this.saveModelForm.controls.gtin;

    if (isUPC) {
      gtinControl.setValue(this.drugCharacteristicsModel.drugId);
      this.saveModelForm.controls.gtin.setValue(this.drugCharacteristicsModel.drugId);
      gtinControl.disable();
    } else {
      gtinControl.enable();
    }
  }

}
